import { useMemo } from 'react';

import { PatientSimple } from '@dreryk/egabinet-patient-frontend-api';
import { Visit, VisitContinuouslyUsedMedicine } from '@dreryk/egabinet-visit-frontend-api';

import { Table, TableKeyExtractor } from '@dreryk/react-components';

import { VisitDiagnoses } from '~libs.shared.visit';

import { useVisitContinuouslyUsedMedicineTableColumns } from './VisitContinuouslyUsedMedicineTable.hooks';

type VisitContinuouslyUsedMedicineTableProps = {
   readonly visitId: Visit['id'];
   readonly patientId: PatientSimple['id'];
   readonly readonly?: boolean;
   readonly continuouslyUsedMedicines: VisitContinuouslyUsedMedicine[] | undefined;
   visitDiagnoses: VisitDiagnoses;
};

export enum ContinuouslyUsedMedicinesPrescriptionStatus {
   ACCEPTED = 'ACCEPTED',
   DRAFT = 'DRAFT',
   NO_PRESCRIPTION = 'NO_PRESCRIPTION',
}

const keyExtractor: TableKeyExtractor<VisitContinuouslyUsedMedicine> = (bean: VisitContinuouslyUsedMedicine) =>
   bean.patientContinuouslyUsedMedicine.id;

const VisitContinuouslyUsedMedicineTable = (props: VisitContinuouslyUsedMedicineTableProps): JSX.Element => {
   const columns = useVisitContinuouslyUsedMedicineTableColumns(
      props.visitId,
      props.readonly,
      props.patientId,
      props.visitDiagnoses
   );
   const dataConfiguration = useMemo(() => ({ data: props.continuouslyUsedMedicines! }), [
      props.continuouslyUsedMedicines,
   ]);

   return (
      <Table<VisitContinuouslyUsedMedicine>
         testId='visitContinuouslyUsedMedicines'
         compact
         columns={columns}
         dataConfiguration={dataConfiguration}
         keyExtractor={keyExtractor}
         pageSize={100}
      />
   );
};

export { VisitContinuouslyUsedMedicineTable };
